//
// Copyright 2026 DXOS.org
//

import * as Schema from 'effect/Schema';

import { Annotation, DXN, Type } from '@dxos/echo';

/**
 * Unit of knowledge generated by an agent.
 */
export class Memory extends Type.makeObject<Memory>(DXN.make('org.dxos.type.memory', '0.1.0'))(
  Schema.Struct({
    title: Schema.String,
    content: Schema.String,
  }).pipe(
    Annotation.LabelAnnotation.set(['title']),
    Annotation.IconAnnotation.set({ icon: 'ph--brain--regular', hue: 'pink' }),
    Annotation.HiddenAnnotation.set(true),
  ),
) {}
